import { vec2, vec3, vec4 } from "gl-matrix";

export type UniformTypeName =
  | "float"
  | "uint"
  | "vec2"
  | "vec3"
  | "vec4"
  | "mat4";
export type UniformTypeNameToType<T extends UniformTypeName> = {
  float: number;
  uint: number;
  vec2: vec2;
  vec3: vec3;
  vec4: vec4;
  mat4: Float32Array;
}[T];

export class Uniform<N extends UniformTypeName> {
  private readonly location: WebGLUniformLocation | null;

  constructor(
    private readonly gl: WebGL2RenderingContext,
    readonly shader: WebGLShader,
    readonly name: string,
    private readonly uniformType: N,
  ) {
    gl.useProgram(shader);

    this.location = gl.getUniformLocation(shader, name);
    if (!this.location) {
      console.warn(
        `Uniform "${name}" not found in shader - uniform is either unused or the name is incorrect`,
      );
    }
  }

  public update(value: UniformTypeNameToType<N>) {
    if (!this.location) {
      return;
    }

    switch (this.uniformType) {
      case "float":
        this.gl.uniform1f(this.location, value as number);
        break;
      case "uint":
        this.gl.uniform1ui(this.location, value as number);
        break;
      case "vec2":
        this.gl.uniform2fv(this.location, value as vec2);
        break;
      case "vec3":
        this.gl.uniform3fv(this.location, value as vec3);
        break;
      case "vec4":
        this.gl.uniform4fv(this.location, value as vec4);
        break;
      case "mat4":
        this.gl.uniformMatrix4fv(this.location, false, value as Float32Array);
        break;
    }
  }
}
